export function shortCommodities(fullName: string): string {

  switch (fullName) {
    case "Cotton": return "CT";
    case "Oilseed Rapeseed / Canola":
    case "Rapeseed/Canola":
      return "OSR";
    case "Sugarcane": return "SC";
    case "Sugar beet":
    case "Sugarbeet":
      return "SB";
    case "Corn Silage": return "CS";
    case "Potatoes": return "PT";
    case "Tomatoes": return "TT";
    case "Strawberries": return "ST";
    case "Sunflower": return "SF";
    case "Pears": return "PR";
    case "Watermelon": return "WM";
    case "Chillies": return "CL";
    case "Cucumbers": return "CB";
    case "Orange+Lemon&Lime+Tangarines, mandarins clem.+Grapefruit (incl.pomelos)+Citrus Fruit, nes": return "Citrus";
    default: return fullName;
  }
} 